import React, { useState } from 'react';
import Header from './header';
import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar';

const Layout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const closeSidebar = () => setSidebarOpen(false);

    return (
        <div style={{ height: '100vh', backgroundColor: '#fdf9f2', overflow: 'hidden' }}>
            <Header onMenuClick={() => setSidebarOpen(true)} />
            <div
                className={`sidebar-overlay ${sidebarOpen ? 'sidebar-overlay-visible' : ''}`}
                onClick={closeSidebar}
                onKeyDown={(e) => e.key === 'Escape' && closeSidebar()}
                role="button"
                tabIndex={0}
                aria-label="Close menu"
            />
            <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
            <Outlet />
            {children}
        </div>
    );
}

export default Layout;
